import { useQuery } from "@tanstack/react-query";
import { useAppContext } from "contexts";
import { ApiDataResponse } from "types/api";
import { ExceptionHandlingType } from "types/apiServiceTypes";
import { LeaderboardProvider } from "types/leaderboard";

export function useLeaderboardProviders() {
  const { apiService } = useAppContext();
  return useQuery<LeaderboardProvider[]>({
    queryKey: [useLeaderboardProviders.name],
    queryFn: async () => {
      const response = await apiService.get<ApiDataResponse<LeaderboardProvider[]>>(
        "/admin/leaderboard/leaderboard-providers",
        {
          exceptionHandlingType: ExceptionHandlingType.AUTOMATIC,
        }
      );
      return response.data;
    },
    initialData: [], // Initial empty array if no data exists yet
  });
}
